export default {
  //
  //Widget options
  //
  isPreChat(state) {
    if (!(state.widget && state.widget.options))
      return ''
    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    return state.widget && state.widget.options ? state.widget.options[_state + '_form'].prechat : true
  },
  getPrechatTitle(state) {
    if (!(state.widget && state.widget.options))
      return ''
    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    return state.widget.options[_state + '_form'].labels.form_title
  },
  getPrechatSub(state) {
    if (!(state.widget && state.widget.options))
      return ''
    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    return state.widget.options[_state + '_form'].labels.form_title_sub
  },
  getPreChatLabels(state) {
    if (!(state.widget && state.widget.options))
      return {}
    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    return state.widget.options[_state + '_form'].labels
  },
  getPreChatFields(state) {
    const list = []

    if (!(state.widget && state.widget.options))
      return list

    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    const _fields = state.widget.options[_state + '_form'].fields
    const _order = state.widget.options[_state + '_form'].order

    for (var i in _order) {
      let item = _fields[_order[i]]
      if (item && item.visible)
        list.push(item)
    }

    return list
  },
  getPreChatRef(state) {

    if (!(state.widget && state.widget.options))
      return {}

    const _state = state.widget.onlineAgentsList ? 'online' : 'offline'
    const _fields = state.widget.options[_state + '_form'].fields

    return _fields

  },
}
